import { ReactNode } from 'react';
import { Button, Modal } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';
import { createGlobalModal, GlobalModalProps } from '../../utils/createGlobalModal';

type StopTestModalProps = {
  title: string;
  description: ReactNode;
  confirmButtonText: string;
  confirmButtonIsLoading?: boolean;
  confirmButtonKind: 'primary' | 'danger';
  cancelButtonText?: string;
  modalSize?: 's' | 'm' | 'l' | 'fullscreen';
};

export function StopTestModal({
  title,
  description,
  confirmButtonText,
  confirmButtonKind,
  confirmButtonIsLoading,
  cancelButtonText,
  modalSize = 's',
  onCancel,
  onSubmit,
}: StopTestModalProps & GlobalModalProps<void, void>) {
  const { t } = useTranslation('engage', { keyPrefix: 'project' });

  return (
    <Modal isOpen contentLabel={title} size={modalSize} onClose={onCancel}>
      <Modal.Header title={title} />
      <Modal.Body>{description}</Modal.Body>
      <Modal.Footer>
        <Button kind="ghost" onClick={() => onCancel()}>
          {cancelButtonText || t('modal.cancel')}
        </Button>
        <Button
          isLoading={confirmButtonIsLoading}
          kind={confirmButtonKind}
          onClick={() => onSubmit()}
        >
          {confirmButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export const openStopTestModal = createGlobalModal<StopTestModalProps, void, void>(StopTestModal);
